import { render } from "./HeadsUpContent.vue?vue&type=template&id=501ba58c&scoped=true"
const script = {}

import "./HeadsUpContent.vue?vue&type=style&index=0&id=501ba58c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501ba58c"]])

export default __exports__